export default {
  namespace: true,
  state: () => ({
    listInitParams: null // 存储在线订单列表页面参数（查询参数和分页参数），为了解决跳转至详情页面再返回去页面数据刷新
  }),
  mutations: {
    updateListInitParams (state, payload) {
      state.listInitParams = payload
    }
  },
  actions: {
    updateActionListInitParams ({ commit }, payload) {
      commit('updateListInitParams', payload)
    }
  }
}



// WEBPACK FOOTER //
// ./src/store/modules/order.js